/**
 * Ruts Atelier — Drawer móvil editorial.
 * Autocontenido y resistente al doble render del header de Horizon
 * (carga inicial + hidratación de sección). Usa un ÚNICO overlay canónico
 * portado a <body> (evita el `contain:layout` del header) y apertura por
 * delegación de eventos. Gestiona scroll-lock, focus-trap, Escape, cierre por
 * overlay y acordeón single-open (Mujer/Hombre).
 */
(function () {
  var LOCK = 'data-ruts-locked';
  var OV_ID = 'ruts-mdrawer-overlay';

  var overlay = null;
  var panel = null;
  var scrollY = 0;
  var keyHandler = null;
  var lastFocus = null;

  // Deja un único overlay canónico en <body> y elimina los duplicados.
  function canonicalize() {
    var overlays = Array.prototype.slice.call(document.querySelectorAll('[data-ruts-overlay]'));
    if (!overlays.length) return null;

    var canonical = document.getElementById(OV_ID);
    if (!canonical || !document.body.contains(canonical)) {
      canonical = overlays[overlays.length - 1];
    }
    canonical.id = OV_ID;
    overlays.forEach(function (o) { if (o !== canonical) o.remove(); });
    if (canonical.parentElement !== document.body) document.body.appendChild(canonical);
    return canonical;
  }

  function setup() {
    var next = canonicalize();
    if (!next) return;
    overlay = next;
    panel = overlay.querySelector('[data-ruts-panel]');
    if (overlay.dataset.rutsBound === '1') return;
    overlay.dataset.rutsBound = '1';

    var scrim = overlay.querySelector('[data-ruts-scrim]');
    if (scrim) scrim.addEventListener('click', close);
    overlay.querySelectorAll('[data-ruts-close]').forEach(function (b) { b.addEventListener('click', close); });
    panel.querySelectorAll('a[href]').forEach(function (a) {
      a.addEventListener('click', function () { setTimeout(close, 0); });
    });
    var accs = Array.prototype.slice.call(panel.querySelectorAll('[data-ruts-acc]'));
    accs.forEach(function (a) {
      a.addEventListener('toggle', function () {
        if (!a.open) return;
        accs.forEach(function (o) { if (o !== a && o.open) o.open = false; });
      });
    });
  }

  function focusable() {
    if (!panel) return [];
    return Array.prototype.slice
      .call(panel.querySelectorAll('a[href],button:not([disabled]),summary,input,select,textarea,[tabindex]:not([tabindex="-1"])'))
      .filter(function (el) {
        if (el.disabled) return false;
        var r = el.getBoundingClientRect();
        if (r.width === 0 && r.height === 0) return false;
        if (typeof el.checkVisibility === 'function') {
          return el.checkVisibility({ contentVisibilityAuto: true, opacityProperty: true, visibilityProperty: true });
        }
        return true;
      });
  }

  function lock() {
    scrollY = window.scrollY || document.documentElement.scrollTop || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = '-' + scrollY + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    b.setAttribute(LOCK, '1');
  }
  function unlock() {
    var b = document.body;
    if (b.getAttribute(LOCK) !== '1') return;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    b.removeAttribute(LOCK);
    window.scrollTo(0, scrollY);
  }
  function setExpanded(v) {
    document.querySelectorAll('[data-ruts-mdrawer] [data-ruts-open]').forEach(function (b) { b.setAttribute('aria-expanded', v ? 'true' : 'false'); });
  }
  function onKey(e) {
    if (!overlay) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusable();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    // Si el foco está fuera del panel (p.ej. en el botón que abre, tras el
    // overlay), cualquier Tab lo devuelve al interior: nunca sale del drawer.
    var inPanel = panel && panel.contains(document.activeElement);
    if (e.shiftKey) {
      if (!inPanel || document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (!inPanel || document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }
  // Lleva el foco al interior del panel abierto (re-consulta el overlay vivo
  // para no depender de referencias que la re-hidratación pudiera invalidar).
  function focusIntoPanel() {
    var ov = document.querySelector('[data-ruts-overlay].is-open');
    var p = ov && ov.querySelector('[data-ruts-panel]');
    if (!p) return;
    var t = p.querySelector('[data-ruts-close]') || p.querySelector('a[href],button:not([disabled])');
    if (t) t.focus();
  }
  function open() {
    if (!overlay || overlay.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    overlay.classList.add('is-open');
    setExpanded(true);
    lock();
    keyHandler = onKey;
    document.addEventListener('keydown', keyHandler);
    // El foco entra en el panel. Se reintenta tras el tick del evento activador
    // (macrotarea), porque el navegador restaura el foco al botón en el mismo
    // tick del click/Enter y pisaría un focus síncrono.
    focusIntoPanel();
    requestAnimationFrame(focusIntoPanel);
    setTimeout(focusIntoPanel, 0);
  }
  function close() {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    overlay.classList.remove('is-open');
    setExpanded(false);
    unlock();
    if (keyHandler) { document.removeEventListener('keydown', keyHandler); keyHandler = null; }
    // El foco vuelve SIEMPRE al botón que abre el menú (accesibilidad).
    var opener = document.querySelector('[data-ruts-mdrawer] [data-ruts-open]');
    var back = (opener && opener.focus) ? opener : lastFocus;
    if (back && back.focus) back.focus();
  }

  // Apertura por delegación: funciona con cualquier instancia del header.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-ruts-mdrawer] [data-ruts-open]') : null;
    if (!btn) return;
    e.preventDefault();
    setup();
    open();
  });

  // Apertura explícita por teclado (Enter / Espacio) sobre el botón, además de
  // la activación nativa del <button>. Hace la apertura por teclado robusta y
  // verificable, sin depender solo de la semántica nativa.
  document.addEventListener('keydown', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-ruts-mdrawer] [data-ruts-open]') : null;
    if (!btn) return;
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' || e.key === 'Space') {
      e.preventDefault();
      setup();
      open();
    }
  });

  // Reconcilia SIEMPRE a un único overlay canónico. Horizon re-hidrata el
  // header tras el arranque y reinyecta un overlay huérfano; sin esto quedaría
  // en el DOM (invisible) hasta el primer click. El observer lo elimina apenas
  // aparece, así el primer toque encuentra ya un único overlay ligado.
  var reconcileScheduled = false;
  function reconcile() {
    reconcileScheduled = false;
    var ovs = document.querySelectorAll('[data-ruts-overlay]');
    var canon = document.getElementById(OV_ID);
    var dirty = ovs.length > 1 || !canon || canon.parentElement !== document.body || canon.dataset.rutsBound !== '1';
    if (dirty) setup();
  }
  function scheduleReconcile() {
    if (reconcileScheduled) return;
    reconcileScheduled = true;
    var raf = window.requestAnimationFrame || function (fn) { return window.setTimeout(fn, 16); };
    raf(reconcile);
  }
  function observe() {
    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var nd = added[j];
          if (nd.nodeType !== 1) continue;
          if ((nd.matches && nd.matches('[data-ruts-overlay]')) ||
              (nd.querySelector && nd.querySelector('[data-ruts-overlay]'))) {
            scheduleReconcile();
            return;
          }
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  function boot() {
    setup();
    observe();
    // Barrido acotado: Horizon reinyecta el overlay huérfano en distintos
    // instantes de la hidratación. Reconciliamos varias veces durante ~2 s
    // para garantizar un único overlay en reposo, sin depender del observer.
    var t = [0, 60, 200, 500, 1000, 2000];
    for (var i = 0; i < t.length; i++) setTimeout(reconcile, t[i]);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function () { unlock(); setup(); });
})();
